module.exports = __webpack_public_path__ + "img/pageinteriors_individuos-y-familias-03salud.bd26ad96.jpg";